import { render, staticRenderFns } from "./RadishPicAnalyse.vue?vue&type=template&id=8c654084&scoped=true&"
import script from "./RadishPicAnalyse.vue?vue&type=script&lang=js&"
export * from "./RadishPicAnalyse.vue?vue&type=script&lang=js&"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=8c654084&scoped=true&lang=css&"
import style1 from "./RadishPicAnalyse.vue?vue&type=style&index=1&id=8c654084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c654084",
  null
  
)

export default component.exports